import React from 'react'
import { IconButton, IconButtonProps } from '@mui/material'
import { IconX } from '@tabler/icons-react'

const CloseButton: React.FC<IconButtonProps> = (props) => {
  return (
    <IconButton {...props}>
      <IconX stroke={2} size={18} />
    </IconButton>
  )
}

export default CloseButton
